import { FETCH_POWER_BENCHMARKS_SUCCESS } from '../../actions/ActionTypes';

const normalizePowerRanges = (benchmarks) => {
    return benchmarks.reduce((carry, benchmark) => {
        const { gender, category } = benchmark;
        const genderKey = gender.toLowerCase();

        if (!carry[genderKey]) {
            carry[genderKey] = {};
        }

        carry[genderKey][category] = benchmark;

        return carry;
    }, {});
};

const fetchPowerBenchmarksSuccess = (state, { benchmarks }) => {
    if (!Array.isArray(benchmarks)) return state;

    return normalizePowerRanges(benchmarks);
};

const handlers = { [FETCH_POWER_BENCHMARKS_SUCCESS]: fetchPowerBenchmarksSuccess };

export default function powerBenchmarks(state = {}, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
